import { IUserPreferences } from '../interfaces/user-preferences.interface';

export interface CreateUserDto {
    organizationName: string;
    email: string;
    firstName: string;
    lastName: string;
    title?: string;
    phoneNumber?: string;
    photoURL?: string;
    locale: string;
    acceptPolicy: boolean;
    subscribeMarketing?: boolean;
    countryISO31661Alpha2Code: string;
    preferences?: IUserPreferences;
}
